import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Markdown from "markdown-to-jsx";
/* eslint import/no-webpack-loader-syntax: off */
import EXE from "!raw-loader!./Exercise08/EXE.md";
import CNC from "!raw-loader!./Exercise08/CNC.md";
import Link from "@material-ui/core/Link";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

function SimpleCard(props) {
  const { classes } = props;

  const mdconfig = {
    overrides: {
      h1: {
        component: Typography,
        props: {
          variant: "h5", color: "primary"
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: "h5", color: "secondary"
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: "h6",
          color: "textSecondary",
          className: classes.para
        }
      },
      a: {
        component: Link,
        props: {
          target: "_blank"
        }
      },
      p: {
        component: Typography,
        props: {
          paragraph: true,
          className: classes.para
        }
      },
      ul: {
        component: Typography,
        props: {
          component: "ul",
          className: classes.para
        }
      },
      em: {
        props: {
          className: classes.para
        }
      },
      pre: {
        props: {
          // className: "w3-panel w3-card w3-light-grey"
          className: "w3-card "
        }
      },
      code: {
        props: {
          className: "w3-code jsHigh notranslate"
        }
      }
    }
  };

  return (
    <div>
      {/* <Markdown options={mdconfig}>{EDA}</Markdown> */}
      <Card className={classes.card}>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Mar 06, 2019
          </Typography>
          <Typography variant="h5" component="h2">
            Computer-Controlled Machining
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            machines, stock, vendors, job shops, tooling, speeds and feeds,
            lubricants, abrasive machining, grinding, fixturing, sacrificial
            layers, squaring, dust collection, flexures, living hinges, kerfing,
            joinery, reciprocal frame, toolpaths, CAM, file formats, safety,
            welding
          </Typography>
          <Typography component="p">
            group project:
            <br />
            {
              '"test runout, alignment, speeds, feeds, and toolpaths for your machine"'
            }
            <br />
            individual project:
            <br />
            {'" make (design+mill+assemble) something big"'}
            <br />
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            href="http://academy.cba.mit.edu/classes/computer_machining/index.html"
            target="_blank"
            size="small"
          >
            Learn More
          </Button>
        </CardActions>
        <Divider />
      </Card>
      <br />
      <div className={classes.root}>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>CNC - ShopBot</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{CNC}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              Making something BIG
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{EXE}</Markdown>
            {/* <Markdown>{EDA}</Markdown> */}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
